import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Textarea } from '../ui/Textarea';
import { Input } from '../ui/Input';
import { yesNoOptions, shippingCostOptions } from '../../data/intakeOptions';
import { toOptions } from '../../utils/options';
import { MascotPanel } from '../ui/MascotPanel';
export function Step9Type() {
  const {
    data,
    updateData
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-629" data-mp="fmrih8tmjolg">
      <MascotPanel message="Laten we het technisch maken. Wat voor type website bouwen we en welke functionaliteiten zijn onmisbaar?" detailedInfo="Dit formulier is geen indicatie! Hier maakt u echte keuzes voor uw project. De opties die u hier kiest bepalen welke pagina's u in de volgende stap kunt selecteren." data-id="element-630" data-mp="on66ifxz3hsn" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-631" data-mp="j059qjtkmsey">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-632" data-mp="e0sd57cwe6z6">Type Website</h2>

        <div data-id="element-633" data-mp="dyoa0rmtpbzy">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-634" data-mp="dyfzh6e6airx">
            Wat voor type website heeft u nodig?
          </label>
          <RadioGroup columns={1} value={data.websiteType} onChange={val => updateData({
          websiteType: val
        })} options={[{
          value: 'website',
          label: 'Website',
          description: "Meerdere pagina's en opties (geen verkoop van producten)"
        }, {
          value: 'webshop',
          label: 'Webshop',
          description: 'Verkoop van spullen met winkelwagen en afrekenen'
        }, {
          value: 'onepager',
          label: 'Onepager',
          description: 'Homepagina en verder niets (evt. 1 extra pagina of blogs)'
        }]} data-id="element-635" data-mp="16oernannyw0t" />
        </div>

        <AnimatePresence data-id="element-636" data-mp="1zjmamnujf7ak">
          {data.websiteType === 'webshop' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-637" data-mp="1zlp9lxdo4arf">
              <h3 className="font-semibold text-gray-900" data-id="element-638" data-mp="11w45ro3zypbu">Webshop Details</h3>
              <Input label="Hoeveel producten verwacht u ongeveer te verkopen?" placeholder="Bijv. 25, 150 of 1000+" value={data.numProducts} onChange={e => updateData({
            numProducts: e.target.value
          })} data-id="element-639" data-mp="11y70umk0b8nf" />
              <Textarea label="Hoe wilt u dat de producten erin worden gezet?" placeholder="Bijv. handmatig, via een import, koppeling met boekhouding..." value={data.productManagement} onChange={e => updateData({
            productManagement: e.target.value
          })} data-id="element-640" data-mp="x8mfbx9g5kmr" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-641" data-mp="1fwrhx1edazjz">
                <Input label="Welke betaalmethodes wilt u aanbieden?" placeholder="Bijv. iDEAL, creditcard, achteraf betalen" value={data.paymentProviders} onChange={e => updateData({
              paymentProviders: e.target.value
            })} data-id="element-642" data-mp="1ayhmqqsn7yyd" />
                <Input label="Hoe worden producten verzonden?" placeholder="Bijv. PostNL, DHL, afhalen" value={data.shippingMethods} onChange={e => updateData({
              shippingMethods: e.target.value
            })} data-id="element-643" data-mp="3jeh9pc25xa8s" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-644" data-mp="30fv7ftuwtd3a">
                <div data-id="element-645" data-mp="30i7qkacelthx">
                  <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-646" data-mp="35fhm87qdz1e7">
                    Hebben producten varianten (maat, kleur)?
                  </label>
                  <RadioGroup columns={2} value={data.productVariations} onChange={val => updateData({
                productVariations: val
              })} options={toOptions(yesNoOptions)} data-id="element-647" data-mp="3ac82ow63rz05" />
                </div>
                <div data-id="element-648" data-mp="2a5ba9sbz5hqk">
                  <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-649" data-mp="2a7xh1pr1jt7q">
                    Moet de voorraad bijgehouden worden?
                  </label>
                  <RadioGroup columns={2} value={data.stockManagement} onChange={val => updateData({
                stockManagement: val
              })} options={toOptions(yesNoOptions)} data-id="element-650" data-mp="20eqgqjb5r3ei" />
                </div>
              </div>
              <div data-id="element-651" data-mp="1meyxa31vgut4">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-652" data-mp="1miwgspsd3odj">
                  Hoe wilt u verzendkosten rekenen?
                </label>
                <RadioGroup columns={2} value={data.shippingCosts} onChange={val => updateData({
              shippingCosts: val
            })} options={toOptions(shippingCostOptions)} data-id="element-653" data-mp="1cjnqc6wpgrvx" />
              </div>
            </motion.div>}

          {(data.websiteType === 'website' || data.websiteType === 'webshop') && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-654" data-mp="19yppml2rcxni">
              <h3 className="font-semibold text-gray-900" data-id="element-655" data-mp="1sw0pa6saxt3h">
                Portaal & Gebruikers
              </h3>

              <div data-id="element-656" data-mp="1e1m542x04dn8">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-657" data-mp="1iycgwe1rwn2u">
                  Moet er een klantenportaal komen?
                </label>
                <RadioGroup columns={2} value={data.needsPortal} onChange={val => updateData({
              needsPortal: val
            })} options={[{
              value: 'yes',
              label: 'Ja, klanten moeten kunnen inloggen'
            }, {
              value: 'no',
              label: 'Nee, dat is niet nodig'
            }]} data-id="element-658" data-mp="2j1gbc4s45sp" />
              </div>

              {data.needsPortal === 'yes' && <div className="space-y-6 mt-4" data-id="element-659" data-mp="1y2oz728axnk3">
                  <Textarea label="Wat moet het portaal onthouden/tonen aan de klant?" placeholder="Bijv. bestelgeschiedenis, facturen, afspraken..." value={data.portalDetails} onChange={e => updateData({
              portalDetails: e.target.value
            })} data-id="element-660" data-mp="1xzt2tic3r6xr" />
                  <Textarea label="Zijn er meerdere mensen met verschillende rollen?" placeholder="Bijv. beheerder, medewerker, klant..." value={data.userRoles} onChange={e => updateData({
              userRoles: e.target.value
            })} data-id="element-661" data-mp="246gsycm2fyze" />
                </div>}
            </motion.div>}
        </AnimatePresence>

        <div className="bg-blue-50 rounded-xl p-6 border border-blue-100" data-id="element-662" data-mp="2s32vq4j201eh">
          <p className="text-sm text-blue-800" data-id="element-663" data-mp="2wuuqkr98staf">
            <strong data-id="element-664" data-mp="2wv4f0aen2se0">Goed om te weten:</strong> Wij bouwen onze websites altijd
            in WordPress, gecombineerd met Elementor (en WooCommerce voor
            webshops). Dit zorgt voor een flexibel en gebruiksvriendelijk
            systeem.
          </p>
        </div>
      </div>
    </motion.div>;
}